module.exports = __webpack_public_path__ + "img/icon-kartu-kredit.c60af760.svg";